module.exports = __webpack_public_path__ + "media/images/media-elements/chapters-bcaf6bac388e9da5d70d2f96c08cc0b1.svg";